<div class="simple-dialog cancel-dialog">
  <div class="simple-dialog__header">
    <h2 class="simple-dialog__title">{{title}}</h2>
  </div>
  <div>
    {{text}}
  </div>
  <div class="simple-dialog__actions">
    <button type="button" mat-button [mat-dialog-close]="false" class="simple-dialog__button">
      {{cancelText}}
    </button>
    <button cdkFocusInitial type="button" mat-button [mat-dialog-close]="true" class="simple-dialog__button simple-dialog__button_primary">
      {{okText}}
    </button>
  </div>
</div>
